import { CommentSection } from './CommentSection'
import { withCommentSection } from './withCommentSection'

const ConnectedCommentSection = withCommentSection(CommentSection)
export { ConnectedCommentSection as CommentSection }
